module.exports = __webpack_public_path__ + "img/873-c64488.png";